import React, { useEffect, useState } from 'react';
import DropButton from './DropButton';

import { fetchMainCategories, fetchSubCategories } from '../helpers/fetchApi';
import '../style/menu.css';

interface Provider {
  id_depto: number;
  pai: number;
  depto: string;
  tx_url: string;
}

const Menu: React.FC = () => {
  const [mainCategory, setMainCategory] = useState<Provider[]>([]);
  const [categoriesNv2, setCategoriesNv2] = useState<Provider[]>([]);
  const [categoriesNv3, setCategoriesNv3] = useState<Provider[]>([]);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [selectedCategory, setSelectedCategory] = useState<number>(0);

  async function fetchDataOp() {
    const data = await fetchMainCategories();
    setMainCategory(data);
  }
  useEffect(() => {
    fetchDataOp();
  }, []);

  useEffect(() => {
    async function fetchdata() {
      const data = await fetchSubCategories(selectedId);
      setCategoriesNv2(data);
    }
    fetchdata();
  }, [selectedId]);

  useEffect(() => {
    async function fetchdata() {
      const data = await fetchSubCategories(selectedCategory);
      setCategoriesNv3(data);
    }
    fetchdata();
  }, [selectedCategory]);

  function mapMainCategory() {
    return mainCategory.map(({ depto, id_depto }) => (
      <DropButton
        key={id_depto}
        id={id_depto}
        name={depto}
        setSelectedId={setSelectedId}
        selected={selectedId === id_depto}
      />
    ));
  }

  function mapNv2Categories() {
    let timer: ReturnType<typeof setTimeout>;
    const second = 400;
    return categoriesNv2.map(({
      pai, id_depto, depto, tx_url,
    }) => {
      if (selectedId === pai) {
        return (
          <div
            className={`sub-item ${selectedCategory === id_depto && 'sel'}`}
            key={id_depto}
            onMouseEnter={() => {
              timer = setTimeout(() => {
                setSelectedCategory(id_depto);
              }, second);
            }}
            onFocus={() => undefined}
            onMouseLeave={() => clearTimeout(timer)}
          >
            <a className="sub-links" href={`https://www.alobebe.com.br/${tx_url},c,${id_depto}`}>
              {depto.toUpperCase()}
            </a>
            {'>'}
          </div>
        );
      }
      return null;
    });
  }

  function mapNv3Categories() {
    return categoriesNv3.map(({
      pai, id_depto, depto, tx_url,
    }) => {
      if (selectedCategory === 0) {
        return null;
      }
      if (selectedCategory === pai) {
        return (
          <a className="sub-item" href={`https://www.alobebe.com.br/${tx_url},c,${id_depto}`} key={id_depto}>
            {depto.toUpperCase()}
          </a>
        );
      }
      return null;
    });
  }

  function clearSelections() {
    setSelectedCategory(0);
  }

  return (
    <nav className="dropdown2-menu">
      {mapMainCategory()}
      <div className="dropdown-content" onMouseLeave={() => clearSelections()}>
        <div className="row">
          <div className="sub-categories">{mapNv2Categories()}</div>
          <div className="nivel3-menu">{mapNv3Categories()}</div>
        </div>
      </div>
    </nav>
  );
};

export default Menu;
